import * as loadingAction from "../../../../store/loading/action";
import * as messageAction from "../../../../store/message/action";

import { Col, Modal } from "reactstrap";
import {
  GET_DT_BALANCE_COLUMN,
  SAVE_DT_BALANCE_COLUMN,
  GET_CUSTOMER_TYPE,
} from "helpers/url_api_constant";
import React, { useEffect, useState } from "react";
import Select, { OptionProps, components } from "react-select";
import SelectColor, { colorOption } from "components/Custom/SelectColor";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import $ from "jquery";
import BootstrapTable from "react-bootstrap-table-next";
import PropTypes from "prop-types";
import moment from "moment";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";

function ManageColumn(props) {
  const dispatch = useDispatch();

  const [showManageColumn, setShowManageColumn] = useState(false);

  const [columnManageList, setColumnManageList] = useState([]);
  const [customerTypeOption, setCustomerTypeOption] = useState([]);

  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = "white";

    return style;
  };

  const getColumn = () => post(GET_DT_BALANCE_COLUMN, {});
  const getOption = async () => {
    try {
      let res = await post(GET_CUSTOMER_TYPE, {});
      setCustomerTypeOption(
        res.data.customerTypeList
          .map(obj => ({ label: obj.ALIAS_NAME, value: obj.PID }))
          .sort((a, b) => (a.label > b.label ? 1 : b.label > a.label ? -1 : 0))
      );
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
  };
  const handleAddColumn = () => {
    setColumnManageList(prevent => [
      ...prevent,
      {
        ROW: columnManageList.length + 1,
        PID: "",
        BALANCECOLUMN_ORDER: columnManageList.length + 1,
        BALANCECOLUMN_NAME: "",
        BALANCECOLUMN_DESC: "",
        BALANCECOLUMN_SHOW: true,
        PRIORITY_FLAG: 0,
        STATUS_FLAG: 0,
        // color: colorOption[0],
        custtype: [],
        source: { label: "Manual", value: 0 },
        show: { label: "Show", value: 1 },
      },
    ]);
  };
  const handleSaveColumn = async () => {
    function validateDuplicate() {
      let valueArr = columnManageList.map(function (item) {
        return item.BALANCECOLUMN_NAME;
      });
      let isDuplicate = valueArr.some(function (item, idx) {
        return valueArr.indexOf(item) != idx;
      });
      return isDuplicate;
    }
    if (validateDuplicate()) {
      dispatch(messageAction.showMessage("Column name is duplicate."));
      throw "exit";
    }
    dispatch(loadingAction.showLoading());
    try {
      if (
        !columnManageList.some(
          row => row.BALANCECOLUMN_NAME == "" || row.BALANCECOLUMN_ORDER == ""
        )
      ) {
        let data = [...columnManageList];
        data = data.map(row => ({
          ...row,
          BALANCECOLUMN_DESC: row.custtype.map(cus => cus.label).toString(),
        }));
        let res = await post(SAVE_DT_BALANCE_COLUMN, data);
        if (res.resultCode == 200) {
          fetchData();
          props.hide();
          props.onChange();
          dispatch(messageAction.showMessage("Save success."));
        }
      } else {
        dispatch(messageAction.showMessage("Plesae key in."));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  const fetchData = async () => {
    setColumnManageList([]);
    dispatch(loadingAction.showLoading());
    try {
      setShowManageColumn(true);
      let column = await getColumn();
      // console.log(column);
      setColumnManageList(
        column.data.dtBalanceColumnList.map((obj, index) => ({
          ...obj,
          ROW: index + 1,
          // color: colorOption[obj.BALANCECOLUMN_TYPE],
          source:
            obj.STATUS_FLAG == 0
              ? { label: "Manual", value: 0 }
              : obj.STATUS_FLAG == 1
              ? { label: "Scada", value: 1 }
              : { label: "Flow Selection", value: 2 },
          custtype: obj.BALANCECOLUMN_DESC
            ? customerTypeOption.filter(
                opt => obj.BALANCECOLUMN_DESC.split(",").indexOf(opt.label) >= 0
              )
            : [],
          show:
            obj.BALANCECOLUMN_SHOW == 1
              ? { label: "Show", value: 1 }
              : { label: "Hide", value: 0 },
        }))
      );
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }

    dispatch(loadingAction.hideLoading());
  };

  useEffect(() => {
    if (props.show == true) {
      getOption();
      fetchData();
    }
  }, [props.show]);
  useEffect(() => {
    getOption();
  }, []);
  const PickColor = (cellContent, row) => {
    return (
      <SelectColor
        value={cellContent}
        onChange={selected => {
          setColumnManageList(prev => {
            return prev.map(obj => {
              if (row.ROW == obj.ROW) {
                return {
                  ...obj,
                  color: selected,
                  BALANCECOLUMN_TYPE: selected.value,
                };
              }
              return { ...obj };
            });
          });
        }}
      />
    );
  };
  const SelectStyle = {
    option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
      ...provided,
      ...(isFocused && { backgroundColor: "#2E3460" }),
    }),
  };
  const SelectShow = (cellContent, row) => {
    return (
      <Select
        value={cellContent}
        options={[
          { label: "Show", value: 1 },
          { label: "Hide", value: 0 },
        ]}
        classNamePrefix="select2-selection"
        styles={SelectStyle}
        onChange={selected => {
          setColumnManageList(prev => {
            return prev.map(obj => {
              if (row.ROW == obj.ROW) {
                return {
                  ...obj,
                  show: selected,
                  BALANCECOLUMN_SHOW: selected.value,
                };
              }
              return { ...obj };
            });
          });
        }}
      />
    );
  };
  const SelectSource = (cellContent, row) => {
    return (
      <Select
        value={cellContent}
        options={[
          { label: "Manual", value: 0 },
          // { label: "Scada", value: 1 },
          { label: "Flow Selection", value: 2 },
          // { label: "GQMS", value: 3 },
        ]}
        classNamePrefix="select2-selection"
        styles={SelectStyle}
        onChange={selected => {
          setColumnManageList(prev => {
            return prev.map(obj => {
              if (row.ROW == obj.ROW) {
                return {
                  ...obj,
                  source: selected,
                  STATUS_FLAG: selected.value,
                };
              }
              return { ...obj };
            });
          });
        }}
      />
    );
  };
  const SelectCustomerType = (cellContent, row) => {
    return (
      <div>
        <Select
          value={cellContent}
          isClearable={true}
          isMulti
          onChange={selected => {
            setColumnManageList(prev => {
              return prev.map(obj => {
                if (row.ROW == obj.ROW) {
                  return {
                    ...obj,
                    custtype: selected,
                  };
                }
                return { ...obj };
              });
            });
          }}
          options={customerTypeOption}
          classNamePrefix="select2-selection"
          styles={columnOption}
        />
      </div>
    );
  };
  const columnOption = {
    menu: (provided, state) => ({
      ...provided,
      width: 270,
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isFocused ? "#2E3446" : undefined,
      };
    },
    multiValue: (styles, { data }) => {
      return {
        ...styles,
        backgroundColor: "#2A3042",
      };
    },
    multiValueLabel: (styles, { data }) => ({
      ...styles,
      color: "#FFFFFF",
    }),
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: "#BFC8E2",
      ":hover": {
        backgroundColor: "#2A3042",
        color: "white",
      },
    }),
  };
  const columnManage = [
    {
      dataField: "BALANCECOLUMN_ORDER",
      text: "Order",
      headerAlign: "center",
      sort: true,
      editable: true,
      align: "center",
      style: {
        width: "50px",
        cursor:"pointer",
      },
      type: "number",
    },

    {
      dataField: "BALANCECOLUMN_NAME",
      text: "Column Name",
      headerAlign: "center",
      sort: true,
      editable: (content, row, rowIndex, columnIndex) => row.PID == "",
      align: "center",
      style: {
        width: "50px",
      },
    },
    {
      dataField: "source",
      text: "Source",
      headerAlign: "center",
      sort: true,
      editable: false,
      align: "center",
      style: {
        width: "125px",
      },
      sortFunc: (a, b, order, dataField) => {
        if (order === "asc") {
          return b.value - a.value;
        }
        return a.value - b.value; // desc
      },
      formatter: SelectSource,
    },
    {
      dataField: "custtype",
      text: "Customer Type",
      headerAlign: "center",
      sort: true,
      editable: false,
      align: "center",
      style: {
        width: "200px",
      },
      formatter: SelectCustomerType,
    },
    // {
    //     dataField: "BALANCECOLUMN_DESC",
    //     text: "Description",
    //     headerAlign: "center",
    //     sort: true,
    //     editable: true,
    //     align: "center",
    //     style: {
    //         width: "200px",
    //     },
    // },
    // {
    //     dataField: "color",
    //     text: "Color",
    //     headerAlign: "center",
    //     sort: true,
    //     editable: false,
    //     align: "center",
    //     style: {
    //         width: "70px",
    //     },
    //     sortFunc: (a, b, order, dataField) => {
    //         if (order === 'asc') {
    //             return b.value - a.value;
    //         }
    //         return a.value - b.value; // desc
    //     },
    //     formatter: PickColor,
    // },
    {
      dataField: "show",
      text: "Status",
      headerAlign: "center",
      sort: true,
      editable: false,
      align: "center",
      style: {
        width: "100px",
      },
      sortFunc: (a, b, order, dataField) => {
        if (order === "asc") {
          return b.value - a.value;
        }
        return a.value - b.value; // desc
      },
      formatter: SelectShow,
    },
    // {
    //   dataField: "ACTION",
    //   isDummyField: true,
    //   text: "Action",
    //   headerAlign: "center",
    //   align: "center",
    //   style: {
    //     width: "150px",
    //   },
    //   formatter: deleteColumnButton,
    // },
  ];
  return (
    <>
      <Modal size="xl" isOpen={props.show} backdrop={"static"}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">
            Manage Column Balancing & Shrinkage Gas
          </h5>
          <button
            type="button"
            onClick={() => {
              props.hide();
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>{" "}
          </button>
        </div>
        <div className="modal-body">
          <BootstrapTable
            id="collumn-balancing-table"
            wrapperClasses="table-on-scroll"
            keyField="ROW"
            data={columnManageList}
            columns={columnManage}
            rowStyle={rowStyleFontWhite}
            headerClasses="header-style"
            defaultSorted={defaultSortColumnManage}
            cellEdit={cellEditFactory({
              mode: "click",
              blurToSave: true,
              afterSaveCell: (oldValue, newValue, row, column) => {
                // console.log(columnDataList);
              },
            })}
          />
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => handleAddColumn()}
            >
              <i className="bx bx-plus"></i>&nbsp; Add
            </button>

            <button
              type="button"
              className="btn btn-success"
              onClick={() => handleSaveColumn()}
            >
              <i className="bx bx-save"></i>&nbsp; Save
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => props.hide()}
            >
              Close
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}
const defaultSortColumnManage = [
  {
    dataField: "BALANCECOLUMN_ORDER",
    order: "asc", // or desc
  },
];
export default ManageColumn;

const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;

//headerColumn

ManageColumn.propTypes = {
  show: PropTypes.any,
  hide: PropTypes.any,
  onChange: PropTypes.any,
};
